<app-form-manager
    *ngIf="params"
    formPlugin="core-user-form"
    [params]="params"
    (canceled)="cancel($event)"
    #form>
</app-form-manager>
